// TEMPORARY visual harness. Delete after checking.
import React, { useEffect } from 'react';
import GridEditor from './components/crossword/GridEditor';
import puzzles from './__harness_puzzles.json';
import './styles/editor.css';

const base = puzzles.find(p => p.id === '01-01-2026');
const W = 6, H = 7;
const covered = new Set();
base.words.forEach(w => { for (let i = 0; i < w.answer.length; i++) covered.add(w.direction === 'across' ? `${w.startRow}-${w.startCol + i}` : `${w.startRow + i}-${w.startCol}`); });
const blackSquares = [];
for (let r = 0; r < H; r++) for (let c = 0; c < W; c++) if (!covered.has(`${r}-${c}`)) blackSquares.push({ row: r, col: c });
const puzzle = { ...base, id: '14-10-2026', gridSize: { width: W, height: H }, blackSquares };

export default function Harness() {
  const mode = new URLSearchParams(window.location.search).get('harness');
  useEffect(() => {
    const t = setTimeout(() => {
      const inputs = document.querySelectorAll('.clue-input');
      const target = inputs[mode === 'down' ? 11 : 3];
      target?.focus();
      if (mode === 'type') {
        const set = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
        set.call(target, 'kis');
        target.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }, 600);
    return () => clearTimeout(t);
  }, [mode]);
  return <div className="container"><GridEditor puzzle={puzzle} puzzles={puzzles} onSave={() => {}} onBack={() => {}} onDelete={() => {}} onNavigate={() => {}} /></div>;
}
